module.exports = __webpack_public_path__ + "static/media/krx-big7-02.39d2ffce.jpg";